import { useDateTime } from "@hooks/use-date-time";
import { Box } from "@mui/material";

interface Props {
  /** A generic data string */
  date: string;
}

/** Renders a date cell in the the point clouds table */
export function PointCloudDate({ date }: Props): JSX.Element {
  const { formatDate } = useDateTime();

  return <Box component={"var"}>{formatDate(date)}</Box>;
}
